// Shared types + field metadata for the 3-step merge wizard.

// A customer as referenced by the merge entry points (row action, dedupe page).
export interface CustomerSummary {
  _id: string;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  phone?: string | null;
  company?: string | null;
}

// Full identity fields for a record being compared in step 2 (from the
// customerMergeCandidates query; address is a pre-formatted string).
export interface WizardCandidate {
  _id: string;
  first_name?: string | null;
  last_name?: string | null;
  company?: string | null;
  email?: string | null;
  phone?: string | null;
  address?: string | null;
  // Whether the record has a Cognito login. Forces the primary to a
  // login-bearing record; does not restrict which fields can be adopted.
  hasLogin?: boolean | null;
  // Why a merge at this processor can't retire the record (it does business at
  // another processor). It can still be the primary.
  retireBlockedReason?: string | null;
}

// The core identity fields the picker compares — must match the backend
// IDENTITY_FIELDS in models/CustomerMergeOperation.
export const MERGE_FIELDS = [
  { key: 'first_name', label: 'First name' },
  { key: 'last_name', label: 'Last name' },
  { key: 'company', label: 'Company' },
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Phone' },
  { key: 'address', label: 'Address' },
] as const;

export type MergeFieldKey = (typeof MERGE_FIELDS)[number]['key'];

export function candidateLabel(c: WizardCandidate | CustomerSummary): string {
  const name = `${c.first_name ?? ''} ${c.last_name ?? ''}`.trim();
  if (c.company) return name ? `${c.company} — ${name}` : c.company;
  return name || c.email || c._id;
}
